import React, { useState } from 'react';
import { TableCell, IconButton, Tooltip } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { getAddressString } from '#component/addressbook/helper';
import SpanRow from '#component/table/span-row';
import AddressbookActions from '#component/addressbook/dashboard/addressbook-actions';
import ContactActions from '#component/addressbook/dashboard/contact-actions';
import HighlightWord from '#component/general/highlight-word';
import { StyledTableRow, StyledAddressbookLabel } from './styles';

const addressbookCompareFn = (a, b) => a?.addressbook?.id === b?.addressbook?.id;

const ContactTableRow = props => {
  const { contact, index, contacts: self, filter } = props;
  const [hover, setHover] = useState(true);
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [addressbook, setAddressbook] = useState({});

  const handleMouseEnter = () => {
    setHover(false);
  };

  const handleMouseLeave = () => {
    setHover(true);
  };

  const handleAddressbookClick = ab => event => {
    setAddressbook(ab);
    setAnchorEl1(event.currentTarget);
  };

  const handleContactClick = event => {
    setAnchorEl2(event.currentTarget);
  };

  return (
    <>
      <StyledTableRow key={contact.id} hover={hover}>
        <SpanRow
          index={index}
          items={self}
          compareFn={addressbookCompareFn}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <StyledAddressbookLabel
            addressbookLabel={contact.addressbook?.label}
            projectTitle={contact.addressbook?.project?.title}
            onClick={handleAddressbookClick(contact.addressbook)}
          />
        </SpanRow>
        <TableCell align="left">
          <HighlightWord
            textToHighlight={contact.firstName}
            searchWord={filter}
          />
        </TableCell>
        <TableCell align="left">
          <HighlightWord
            textToHighlight={contact.lastName}
            searchWord={filter}
          />
        </TableCell>
        <TableCell align="left">
          <HighlightWord
            textToHighlight={contact.companyName}
            searchWord={filter}
          />
        </TableCell>
        <TableCell align="left">
          <HighlightWord
            textToHighlight={getAddressString(contact)}
            searchWord={filter}
          />
        </TableCell>
        <TableCell align="left">
          <Tooltip title="Contact actions">
            <IconButton size="small" onClick={handleContactClick}>
              <ArrowDropDownIcon />
            </IconButton>
          </Tooltip>
        </TableCell>
      </StyledTableRow>
      <AddressbookActions
        anchorEl={anchorEl1}
        setAnchorEl={setAnchorEl1}
        addressbook={addressbook}
      />
      <ContactActions anchorEl={anchorEl2} setAnchorEl={setAnchorEl2} contact={contact} />
    </>
  );
};

export default ContactTableRow;
